import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"line-height":"13px"} }
const _hoisted_2 = ["src", "height", "width"]
const _hoisted_3 = ["src", "height", "width"]
const _hoisted_4 = { style: {"line-height":"16px","height":"50px","padding":"0 10px"} }
const _hoisted_5 = { class: "fs12 fw600" }
const _hoisted_6 = {
  key: 0,
  class: "fs10 lgrey"
}
const _hoisted_7 = {
  key: 1,
  class: "fs10 lgrey"
}
const _hoisted_8 = {
  key: 0,
  class: "posAb",
  style: {"top":"2px","right":"5px"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loctag)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "ofh rad12 mr15 pointer",
        style: _normalizeStyle(`width: ${_ctx.width}px; height: ${_ctx.totalHeight}px; border: solid 1px rgba(0, 0, 0, 0.097);`),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickLocation && _ctx.clickLocation(...args)))
      }, [
        _createElementVNode("div", {
          class: "upperContent posRe",
          style: _normalizeStyle(`height: ${_ctx.totalHeight}px;`)
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loctag.public_id != `free`)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${_ctx.loctag.keyword}`, `${_ctx.width}x${_ctx.width}`, _ctx.useLocationIcon)),
                  height: _ctx.width,
                  width: _ctx.width
                }, null, 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.$getAssetImageUrl(`/assets/call/call_free.png`),
                  height: _ctx.width,
                  width: _ctx.width
                }, null, 8, _hoisted_3))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.loctag.keyword), 1),
            (_ctx.loctag.address)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.loctag.address), 1))
              : _createCommentVNode("", true),
            ([`online`, `online_oauth`].includes(_ctx.loctag.location_type))
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "オンライン"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.canDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                  width: "20",
                  height: "20",
                  class: "pointer rad10",
                  style: {"box-shadow":"2px 2px 2px rgba(0, 0, 0, 0.3)"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteLocation && _ctx.deleteLocation(...args)))
                }, null, 8, _hoisted_9)
              ]))
            : _createCommentVNode("", true)
        ], 4),
        _hoisted_10
      ], 4))
    : _createCommentVNode("", true)
}